import { FromPageProvider } from "../../providers/FromPageProvider";
import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";

import AuthService from "../../utilities/services/auth.service";

import { TicketExchangeWrapper } from "../../components/TicketExchangeWrapper";

export default function TicketExchangePage() {
  const organization = AuthService.getOrg()[0];

  return (
    <div className="spacer-sm">
      <FromPageProvider>
        <ModalProvider>
          <TicketExchangeWrapper organization={organization} />
        </ModalProvider>
      </FromPageProvider>
    </div>
  );
}
